import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import { __assign, __extends } from "tslib";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import mapSelf from '../util/mapSelf';
import classnames from 'classnames';
import TodayButton from './TodayButton';
import OkButton from './OkButton';
import dayjs from '../dayjs';
injectStyle("components/DatePicker/rc-calendar/style/common/footer.css", "[data-dui-0-122-5~=\"dui-calendar-footer\"]{height:57px;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;border-top:1px solid var(--border-medium,rgba(0,0,0,.08))}[data-dui-0-122-5~=\"dui-calendar-footer\"],[data-dui-0-122-5~=\"dui-calendar-footer-btn\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}[data-dui-0-122-5~=\"dui-calendar-footer-show-ok\"] [data-dui-0-122-5~=\"dui-calendar-footer-btn\"]{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}");
var CalendarFooter = (function (_super) {
    __extends(CalendarFooter, _super);
    function CalendarFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalendarFooter.prototype.getNowEl = function () {
        var props = this.props;
        var showToday = props.showToday, value = props.value;
        return showToday ? h(TodayButton, __assign({}, props, { value: value })) : null;
    };
    CalendarFooter.prototype.getOkBtn = function () {
        var props = this.props;
        var showOk = props.showOk, timePicker = props.timePicker;
        return showOk === true || (showOk !== false && timePicker) ? h(OkButton, __assign({}, props)) : null;
    };
    CalendarFooter.prototype.render = function () {
        var _a;
        var props = this.props;
        var prefixCls = props.prefixCls, timePicker = props.timePicker, renderFooter = props.renderFooter, mode = props.mode, showToday = props.showToday, showOk = props.showOk;
        var extraFooter = renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter(mode);
        if (!showToday && !timePicker && !extraFooter && !showOk) {
            return null;
        }
        var nowEl = this.getNowEl();
        var okBtn = this.getOkBtn();
        return (h("div", { className: classnames(prefixCls + "-footer", (_a = {},
                _a[prefixCls + "-footer-show-ok"] = okBtn,
                _a)) },
            h("span", { className: prefixCls + "-footer-btn" },
                extraFooter,
                mapSelf([nowEl, okBtn]))));
    };
    return CalendarFooter;
}(PureComponent));
CalendarFooter.propTypes = {
    defaultValue: PropTypes.instanceOf(dayjs),
    disabledTime: PropTypes.func,
    mode: PropTypes.string,
    prefixCls: PropTypes.string,
    renderFooter: PropTypes.func,
    selectedValue: PropTypes.instanceOf(dayjs),
    showOk: PropTypes.bool,
    showToday: PropTypes.bool,
    timePicker: PropTypes.element,
    value: PropTypes.instanceOf(dayjs),
};
CalendarFooter.defaultProps = {
    defaultValue: undefined,
    disabledTime: undefined,
    mode: '',
    prefixCls: '',
    renderFooter: undefined,
    selectedValue: undefined,
    showOk: undefined,
    showToday: false,
    timePicker: null,
    value: undefined,
};
delete CalendarFooter.defaultProps.value;
export default CalendarFooter;
